module.exports = "/images/GC review.svg";